import { Wrapper } from './ButtonsWrapper.styled'

const ButtonsWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>
}

export default ButtonsWrapper
